import Control from "../../1. Core/Control";
import NP, {EventArgs, ValueChangedEventArgs} from "../../1. Core/NP";
import TopAppBar from "../../1. Core/Controls/TopAppBar/TopAppBar";
import DataTable from "../../1. Core/Controls/DataTable/DataTable";
import Menu from "../../1. Core/Controls/Menu/Menu";
import Dialog from "../../1. Core/Controls/Dialog/Dialog";
import ListBox, {ListBoxItemArgs} from "../../1. Core/Controls/ListBox/ListBox";

import TournamentDlg from "./TournamentDlg";
import {IItem} from "../../1. Core/Controls/ListBox/ListItem";
import {ServerAPI} from "../../1. Core/ServerAPI";
import {clearAllTournaments, ITournament} from "../../10. Battle/Util";
import IconToggleButton from "../../1. Core/Controls/IconToggleButton/IconToggleButton";


let moment = require('moment');


export default class TournamentsPanel extends Control {
	private _Offset: number;
	private _Count: number;
	private _FilterText: string;
	private _topAppBar: TopAppBar;
	private _list: DataTable;
	public _contextMenu: Menu;
	private _detailsDialog: Dialog;
	private _detailsList: ListBox;

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this.np_render();

		this._Offset = 0;
		this._Count = 100;
		this._FilterText = "";
		this._topAppBar = new TopAppBar({
			Caption: 'Tournaments',
			ParentNode: this._root,
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			ShowSearchButton: false,
			//EvHideSearch: () => this.filterItems(null),
			EvSearch: (s: TopAppBar, e: ValueChangedEventArgs) => this.filterItems(e.Value),
		});

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.add,
			Value: 'Add',
			EvClick: () =>
			{
				(new TournamentDlg({
					AutoDestroy: true,
					EvTournamentEdited: () => this.refresh()
				})).show();
			}
		}))

		this._list = new DataTable({
			ParentNode: this._root,
			ShowPaginator: false,
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this.refresh();
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this.refresh();
			},
			Class: 'app-list--avatars',
			ShowSettingsButton: true,
			Columns: [{
				Content: 'Id',
				PropertyContent: 'Id',
				Width: '50px'
			},{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'Name',
				Width: 'calc(100% - 350px)'
			}, {
				Content: NP.RM.getString("SportType"),
				PropertyContent: 'Type',
				Width: '300px'
			}],
			EvItemContextMenu: (sender: Control, args: EventArgs) =>
			{
				this._getContextMenu().setData(args.Item);
				this._getContextMenu().showContextMenu(args.Event);
			}
		});

		// let pan = NP.createNode(this._root, "tournaments-panel")
		// pan.innerText = "Tournaments panel";
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	_getContextMenu()
	{
		return this._contextMenu || (this._contextMenu = new Menu({
			EvOpening: this._onSettingsMenuOpening.bind(this),
			EvItemSelected: this._onSettingsMenuItemSelected.bind(this)
		}))
	}

	_onSettingsMenuOpening(sender: Menu)
	{
		const items: Array<IItem> = [];
		items.push(
			 {
				 RK: 'Edit',
				 Value: 'Edit'
			 },
			 {
				 RK: 'Delete',
				 Value: 'Delete'
			 },
			 {
				 IsSeparator: true
			 },
			 {
				 RK: 'Details',
				 FontImage: NP.FontImages.info,
				 Value: 'Details'
			 }
		);
		sender.setItems(items);
	}

	_onSettingsMenuItemSelected(sender: Menu, args: ListBoxItemArgs)
	{
		const selectedItem = sender.getData().Info;
		switch (args.Item.getValue())
		{
			case 'Edit':
				(new TournamentDlg({
					AutoDestroy: true,
					Tournament: selectedItem,
					EvTournamentEdited: () => this.refresh()
				})).show();
				break;
			case 'Delete':
				NP.showConfirm({
					Content: 'Are you sure you want to delete tournament?',
					EvOkButtonClick: async () =>
					{
						await ServerAPI.delet(`/tournaments/${selectedItem.Id}`)
						clearAllTournaments()
						this.refresh();
					}
				});
				break;
			case 'Details':
				this._showDetails(selectedItem);
				break;
		}
	}

	_showDetails(selection: ITournament)
	{
		this._detailsDialog = this._detailsDialog || new Dialog({
			Class: 'nopad',
			ShowHeader: true,
			Caption: NP.RM.getString('Details'),
			Content: this._detailsList = new ListBox({
				TwoLines: true,
				Class: 'app-list--non-interactive selectable',
				Selectable: false
			})
		});
		let items = [{
			Value: selection.Id,
			Content: 'Id',
			SecondLine: selection.Id + ''
		}, {
			Value: selection.Name,
			Content: 'Name',
			SecondLine: selection.Name
		}, {
			Value: selection.Date || null,
			Content: 'Date',
			SecondLine: selection.Date ? moment(selection.Date, "YYYY-MM-DD").format(NP.getDayFormat()) : ''
		}, {
			Value: selection.UserInRaiting,
			Content: NP.RM.getString('UserInRaiting'),
			SecondLine: NP.RM.getString(selection.UserInRaiting ? 'Yes' : 'No')
		}, {
			Value: selection.IsPro,
			Content: NP.RM.getString('IsPro'),
			SecondLine: NP.RM.getString(selection.IsPro ? 'Yes' : 'No')
		}];
		items = items.filter((item) => item.Value != null).sort(NP.sortAscContent);
		this._detailsList.setItems(items);
		this._detailsDialog.show();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		if (this._list)
			this._list.setHeight(this._Height - 64);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		if (this._list)
			this._list.setWidth(value);
	}

	filterItems(value: string)
	{
		this._FilterText = value;
		this.refresh();
	}

	async refresh()
	{
		let tournaments = await ServerAPI.callUiApi<ITournament[]>(`/tournaments`)


		if (tournaments)
		{
			this._list.setRows(tournaments.map((item: ITournament) => ({
				Id: item.Id,
				Name: item.Name,
				Place: item.Place || '',
				Date: item.Date ? moment(item.Date, "YYYY-MM-DD").format(NP.getDayFormat()) : '',
				UserInRaiting: NP.RM.getString(item.UserInRaiting ? "Yes" : "No"),
				IsPro: NP.RM.getString(item.IsPro ? "Yes" : "No"),
				Info: item,
				Type: item.Type,
				LogoUrl: item.LogoUrl
			})));
		}
	}
}
